<script lang="ts">
  import { page } from '$app/stores'
  import chatLoader from '$lib/chatloader/context'
  import SignInForm from '$lib/components/auth/SignInForm.svelte'
  import Modals from '$lib/components/modals/modals.svelte'
  import Navigation from '$lib/components/Navigation.svelte'
  import ContentFooter from '$lib/components/shared/ContentFooter.svelte'
  import Spinner from '$lib/components/Spinner.svelte'
  import YoloAuth from '$lib/components/YoloAuth.svelte'
  import state from '$lib/stores/auth-state'
  // import { loadFreatureFlags } from '$lib/stores/feature'
  import SimpleAnalytics from '$lib/components/shared/SimpleAnalytics.svelte'
  import config from 'src/config'
  // import { initTracking } from 'src/utils/track'
  import { setupIntercomInfo } from '$lib/authentication/result'
  import GoogleTagManager from '$lib/components/GoogleTagManager.svelte'
  import FullStory from '$lib/components/shared/FullStory.svelte'
  import { normalizedClient } from '$lib/graphql/makeNormalizedClient'
  import { loadFreatureFlags } from '$lib/stores/feature'
  import { setContextClient } from '@urql/svelte'
  import { initTracking } from 'src/utils/track'
  import { onMount } from 'svelte'
  import SvelteSeo from 'svelte-seo'
  import '../../app.css'

  $: requiresAuthentication = $page.data.requiresAuthentication ?? false
  $: signedIn = $state.signedIn
  $: authDidInitialize = $state.authDidInitialize

  setContextClient(normalizedClient)
  onMount(initTracking)
  onMount(loadFreatureFlags)
  onMount(setupIntercomInfo)
  onMount(
    chatLoader.init({
      provider: 'intercom',
      providerKey: config.intercomAppId,
      loadWhileIdle: true,
      idlePeriod: 10e3,
    }),
  )

  // afterNavigate(trackRouteChange)
</script>

<svelte:head>
  <link rel="shortcut icon" href="/favicon.ico" />
  <meta name="theme-color" content="#FC355C" />
  <title>{$page.data.title}</title>
  <meta name="description" content={$page.data.description} />
  <script
    async
    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1288911576638296"
    crossorigin="anonymous"
  ></script>
</svelte:head>

<!-- <svelte:head>
  <title>Airheart</title>
</svelte:head> -->

{#if requiresAuthentication && !authDidInitialize}
  <main class="min-h-screen bg-white" data-sveltekit-preload-data>
    <Navigation />
    <div class="flex items-center justify-center min-h-screen text-center text-black">
      <Spinner size="md" />
    </div>
  </main>
{:else if requiresAuthentication && !signedIn}
  <nav class="px-6 py-4 border-b-1" data-sveltekit-preload-data>
    <div class="flex items-center leading-none">
      <img src="/airheart-logo-full-new.svg" height={32} width={128} alt="Airheart Logo" />
    </div>
  </nav>
  <div class="flex items-center justify-center min-h-screen" data-sveltekit-preload-data>
    <div class="w-[420px] px-4 sm:px-0">
      <SignInForm>
        <h3 class="py-2 mb-4 text-2xl font-medium leading-8 tracking-tight text-gray-900 sm:mt-8">
          Sign in to Airheart
        </h3>
      </SignInForm>
    </div>
  </div>
{:else}
  <div class="min-h-screen" data-sveltekit-preload-data>
    <Navigation />

    <SvelteSeo
      title={$page.data.title}
      jsonLd={{
        '@type': 'Corporation',
        logo: 'https://airheart.com/airheart-mark.svg',
        url: 'https://airheart.com',
        name: 'Airheart, Inc.',
        sameAs: [
          'https://twitter.com/AirheartInc',
          'https://instagram.com/airheartinc',
          'https://www.linkedin.com/company/airheartinc',
          'https://www.facebook.com/AirheartInc',
        ],
      }}
    />

    <main
      aria-labelledby="main page"
      class="grid grid-cols-12 px-0 mx-auto bg-white lg:px-8 xl:px-8 gap-x-4 lg:gap-x-12 sm:my-4 max-w-screen-2xl"
    >
      <slot />
    </main>
  </div>
  <ContentFooter />
{/if}

<Modals />
<YoloAuth />
<SimpleAnalytics />
<GoogleTagManager />
{#if ($page.url.toString().includes('/stays') || $page.url.toString().includes('/book') || $page.url
    .toString()
    .includes('/trips')) && !$page.url.toString().includes('htl_258EK6gROHQPXGuzdsZUXJhDHhQ')}
  <FullStory />
{/if}
